import { AfterViewChecked, Component, ElementRef, OnInit } from '@angular/core';
import { ActiveRentalService, BookingService, LayoutService, NavigationResolver, NavigationService, BookingModel } from 'app-components';
import * as moment from 'moment';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { BookingErrorCode, ObjectTypeInfo, PageBase, PriceModel, RentalInfo, RentalObjectInfo, RentalStatus } from 't4core';
@Component({
  selector: 'app-choose-specific-trailer',
  templateUrl: './choose-specific-trailer.html',
  standalone: false
})
export class ChooseSpecificTrailerComponent extends PageBase implements OnInit {

  public bookingState: BookingModel;
  public rentalObjects: RentalObjectInfo[][];
  public availableObjects: RentalObjectInfo[] = [];
  public unAvailableObjects: RentalObjectInfo[] = [];
  public reservedObjects: RentalObjectInfo[] = [];
  public selectedObject: RentalObjectInfo = null;
  public loading: boolean = false;
  constructor(
    private navigator: NavigationService,
    el: ElementRef,
    private appService: AppIntegrationService,
    private bookingDataService: BookingService,
    public resolver: NavigationResolver,
    public layout: LayoutService,
    public appSettings: AppSettingsService,
    public activeRentalService: ActiveRentalService) {
    super(el);
    this.bookingState = bookingDataService.getBookingState();
  }


  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.rentalObjects = await this.Api.get<any>("RentalObject/App/GetAllObjects", { locationId: this.bookingState.booking.PickupLocationId });
    this.availableObjects = this.rentalObjects[0];
    this.reservedObjects = this.rentalObjects[1];
    this.unAvailableObjects = this.rentalObjects[2];
    this.setSelectedObject();
    this.sortObjects();
    this.loading = false;
    
  }

  public sortObjects() {
    const selectedTypeId = this.bookingState?.booking?.PrimaryObjectTypeId;
    this.availableObjects.sort((a, b) => {
      const aMatch = a?.Type?.Id === selectedTypeId ? 1 : 0;
      const bMatch = b?.Type?.Id === selectedTypeId ? 1 : 0;
      return bMatch - aMatch;
    });
  }

  public setSelectedObject() {
    const specificObjectId = this.bookingState.specificObject?.Id;
    if (!specificObjectId) {
      return; 
    }

    const found = this.availableObjects.find(obj => obj.Id === specificObjectId);

    if (found) {
      this.selectedObject = found;
      this.availableObjects = this.availableObjects.filter(obj => obj.Id !== specificObjectId);
    }
  }

  public selectAvailableObject(object: RentalObjectInfo) {
    this.bookingDataService.setSpecificObject(object);
    this.bookingState.booking.PrimaryObjectTypeId = object?.Type.Id;
    this.bookingState.booking.PrimaryType = object?.Type;
    this.navigator.executeCommand("Next");
  }
  public isSelected(obj: RentalObjectInfo): boolean {
    return this.bookingState.specificObject?.Id === obj.Id;
  }
}
